import { IPaymentMethod } from 'features/payment/types';

import { PaymentMethodCategories } from '../types';

function classifyPaymentMethods(
  methods: IPaymentMethod[],
  selectedMethodId: string
): PaymentMethodCategories {
  return methods.reduce(
    (methodsCategories, method) => {
      const isSelectedMethod = method.accountIdentifier === selectedMethodId;
      const isPrepaidMethod = !!method.prepaid;
      return {
        selectedMethod: isSelectedMethod ? method : methodsCategories.selectedMethod,
        prepaidPaymentMethod: isPrepaidMethod ? method : methodsCategories.prepaidPaymentMethod,
        unSelectedMethods: isSelectedMethod
          ? methodsCategories.unSelectedMethods
          : [...methodsCategories.unSelectedMethods, method],
      };
    },
    {
      selectedMethod: undefined,
      prepaidPaymentMethod: undefined,
      unSelectedMethods: [],
    }
  );
}

export default classifyPaymentMethods;
